import dataBloedErnstigTAR from "../../../../src/data/ernstige-bloedingen-onder-tar.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  dataBloedErnstigTAR,
  BasicCollapse,
  React
};